(function () {
  var PLAN = '.product-plan';

  function findPlan(re) {
    return Array.prototype.find.call(
      document.querySelectorAll(PLAN),
      function (el) { return re.test(el.textContent || ''); }
    );
  }

  function run() {
    var hash = window.location.hash.replace(/^#/, '');
    if (!hash) return;
    var params = new URLSearchParams(hash);

    (params.get('codes') || '').split(',').filter(Boolean).forEach(function (code) {
      fetch('/discount/' + encodeURIComponent(code.trim()), { credentials: 'same-origin' })
        .catch(function () {});
    });

    if ((params.get('plan') || '').toLowerCase() !== 'onetime') return;

    var wantRe = /one-?time/i;
    var enforcing = true;
    var applying = false;

    // A real click on a plan means the shopper chose for themselves — stop overriding.
    document.addEventListener('click', function (e) {
      if (e.isTrusted && e.target.closest && e.target.closest(PLAN)) enforcing = false;
    }, true);

    function apply() {
      if (!enforcing || applying) return;
      var target = findPlan(wantRe);
      if (!target || target.classList.contains('active')) return;
      applying = true;
      (target.querySelector('.product-plan-header') || target).click();
      setTimeout(function () { applying = false; }, 50);
    }

    var tries = 0;
    (function poll() {
      apply();
      if (++tries < 40 && !findPlan(wantRe)) setTimeout(poll, 250);
    })();

    var root = document.querySelector('product-flexible-plan') || document.body;
    new MutationObserver(apply).observe(root, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();